import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { money, imgSrc } from "@/lib/api";

export const ProductCard = ({ product, index = 0, tall = false }) => {
  const imgs = product?.images || [];
  return (
    <Link
      to={`/product/${product.product_id}`}
      data-testid={`product-card-${product.product_id}`}
      className="group block"
    >
      <div className={`relative overflow-hidden bg-sand ${tall ? "aspect-[3/4] md:aspect-[4/5]" : "aspect-[3/4]"}`}>
        <img
          src={imgSrc(imgs[0])}
          alt={product.name}
          loading="lazy"
          className="absolute inset-0 h-full w-full object-cover transition-[transform,opacity] duration-[1200ms] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-[1.06]"
        />
        {imgs[1] && (
          <img
            src={imgSrc(imgs[1])}
            alt=""
            loading="lazy"
            className="absolute inset-0 h-full w-full object-cover opacity-0 transition-opacity duration-700 group-hover:opacity-100"
          />
        )}
        <span className="absolute left-3 top-3 bg-bone/90 px-2 py-1 font-mono text-[11px] tracking-widest">
          {String(index + 1).padStart(2, "0")}
        </span>
        <span className="absolute bottom-3 right-3 flex h-10 w-10 translate-y-3 items-center justify-center rounded-full bg-ink text-bone opacity-0 transition-[transform,opacity] duration-500 group-hover:translate-y-0 group-hover:opacity-100">
          <ArrowUpRight className="h-4 w-4" />
        </span>
      </div>
      <div className="mt-4 flex flex-col gap-1 sm:flex-row sm:items-start sm:justify-between sm:gap-4">
        <div>
          <h3 className="font-display text-xl leading-tight md:text-2xl">{product.name}</h3>
          <p className="eyebrow mt-1">{product.category} · {product.color}</p>
        </div>
        <span className="font-mono text-sm">{money(product.price)}</span>
      </div>
    </Link>
  );
};
